import config from 'config';

const getLocalType = (id) => config.search.types[id] || 'rest';

export default getLocalType;
